<script>
export default {
  name: 'btn-status-confirmar',
  props: ['Status', 'arrematante'],
  data () {
    return {
      buttonClosed: false,
      opened: false,
      newStatus: null,
      oldStatus: null,
      motivos: {
        rg: false,
        cpf: false,
        cpres: false,
        rgIlegivel: false,
        rgIncorreto: false,
        cpfIlegivel: false,
        cpfIncorreto: false,
        cpresIlegivel: false,
        cpresIncorreto: false,
        cpresEmissao90dias: false,
        cpresConjuge: false,
        cpresTerceiros: false,
        contratoSocial: false,
        contratoSocialIlegivel: false,
        contratoSocialIncorreto: false
      }
    }
  },
  computed: {
    getStatus () {
      return this.Status
    }
  },
  mounted () {
  },
  watch: {},
  destroyed () {
  },
  methods: {
    closeButtonConfig () {
      this.buttonClosed = true
    },
    open (newStatus, oldStatus, cb) {
      this.opened = true
      this.newStatus = newStatus
      this.oldStatus = oldStatus
      this.cb = cb
      this.$nextTick(() => {
        this.$refs.btn.focus()
      })
    },
    close () {
      this.opened = false
    },
    confirm () {
      let motivos = this.motivos
      let motivo = ''

      let doc = this.arrematante.pessoa.tipo === 2 ? 'CNPJ' : 'CPF'
      let endereco = this.arrematante.pessoa.tipo === 2 ? 'Endereço' : 'Residência'

      if (motivos.rg) {
        let rg = []
        if (motivos.rgIlegivel) {
          rg.push('RG Ilegível  - Rasurado, com cortes e/ou incompletos. ')
        }
        if (motivos.rgIncorreto) {
          rg.push('RG Incorreto - Divergente do cadastrado no site.')
        }
        motivo += rg.join(' ')
      }

      if (motivos.cpf) {
        let cpf = []
        if (motivos.cpfIlegivel) {
          cpf.push(`${doc} Ilegível - Rasurado, com cortes e/ou incompletos.`)
        }
        if (motivos.cpfIncorreto) {
          cpf.push(`${doc} Incorreto - Divergente do cadastrado no site.`)
        }
        motivo += cpf.join(' ')
      }

      if (motivos.cpres) {
        let cpres = []
        if (motivos.cpresIlegivel) {
          cpres.push(`Comprovante de ${endereco} Ilegível - Rasurado, com cortes e/ou incompletos.`)
        }
        if (motivos.cpresIncorreto) {
          cpres.push(`Comprovante de ${endereco} Incorreto - Divergente do cadastrado no site.`)
        }
        if (motivos.cpresEmissao90dias) {
          cpres.push(`Comprovante de ${endereco} Emitido no prazo superior a 90 dias. `)
        }
        if (motivos.cpresConjuge) {
          if (this.arrematante.pessoa.tipo === 2) {
            cpres.push(`Comprovante de endereço em nome do(s) Sócio(s) `)
          } else {
            cpres.push(`Comprovante de residência em nome do cônjuge - Enviar Certidão de Casamento e/ou União Estável. `)
          }
        }
        if (motivos.cpresTerceiros) {
          cpres.push(`Comprovante de ${endereco} em nome de terceiros - Enviar comprovação de vínculo. `)
        }
        motivo += cpres.join(' ')
      }

      if (motivos.contratoSocial) {
        let contratosocial = []
        if (motivos.contratoSocialIlegivel) {
          contratosocial.push(`Contrato Social Ilegível - Rasurado, com cortes e/ou incompletos.`)
        }
        if (motivos.contratoSocialIncorreto) {
          contratosocial.push(`Contrato Social Incorreto - Divergente do cadastrado no site.`)
        }
        motivo += contratosocial.join(' ')
      }
      this.cb(this.newStatus, motivo)
      this.close()
    }
  },
  components: {}
}
</script>

<template>
  <div>
    <div class="u-bg-overlay" v-if="opened"></div>
    <div class="u-theme-config-container" :class="{'is-closed': opened}">

      <div class="u-theme-config-panel" style="min-width: 800px; overflow: auto" :class="{'open': opened}">

        <div v-if="opened" class="u-theme-content">

          <strong>Informe o motivo:</strong><br><br>
          <div v-if="newStatus === 98" class="w-full block no-select">
            <div class="form-group">
              <div>
                <div><input id="rg" type="checkbox" v-model="motivos.rg"> <label for="rg" class="control-label">RG OU
                  CNH<span v-if="arrematante.pessoa.tipo === 2"> DO(s) SÓCIO(s)</span></label></div>
                <div class="m-l" v-if="motivos.rg">
                  <div><input id="rgilegivel" type="checkbox" v-model="motivos.rgIlegivel"> <label for="rgilegivel"
                                                                                                   class="control-label">Ilegível
                    - Rasurado, com cortes e/ou incompletos.</label></div>
                  <div><input id="rgincorreto" type="checkbox" v-model="motivos.rgIncorreto"> <label for="rgincorreto"
                                                                                                     class="control-label">Incorreto
                    - Divergente do cadastrado no site.</label></div>
                </div>
              </div>

              <div>
                <div><input id="cpf" type="checkbox" v-model="motivos.cpf"> <label for="cpf" class="control-label"><span
                  v-if="arrematante.pessoa.tipo === 2">CNPJ</span><span v-else>CPF</span></label></div>
                <div class="m-l" v-if="motivos.cpf">
                  <div><input id="cpfilegivel" type="checkbox" v-model="motivos.cpfIlegivel"> <label for="cpfilegivel"
                                                                                                     class="control-label">Ilegível
                    - Rasurado, com cortes e/ou incompletos.</label></div>
                  <div><input id="cpfincorreto" type="checkbox" v-model="motivos.cpfIncorreto"> <label
                    for="cpfincorreto" class="control-label">Incorreto - Divergente do cadastrado no site.</label></div>
                </div>
              </div>

              <div v-if="arrematante.pessoa.tipo === 2">
                <div><input id="contratoSocial" type="checkbox" v-model="motivos.contratoSocial"> <label for="contratoSocial" class="control-label">CONTRATO SOCIAL</label></div>
                <div class="m-l" v-if="motivos.contratoSocial">
                  <div><input id="contratoSocialilegivel" type="checkbox" v-model="motivos.contratoSocialIlegivel"> <label for="contratoSocialilegivel"
                                                                                                     class="control-label">Ilegível
                    - Rasurado, com cortes e/ou incompletos.</label></div>
                  <div><input id="contratoSocialincorreto" type="checkbox" v-model="motivos.contratoSocialIncorreto"> <label
                    for="cpfincorreto" class="control-label">Incorreto - Divergente do cadastrado no site.</label></div>
                </div>
              </div>

              <div>
                <div><input id="cpres" type="checkbox" v-model="motivos.cpres"> <label for="cpres"
                                                                                       class="control-label"><span
                  v-if="arrematante.pessoa.tipo === 2">COMPROVANTE DE ENDEREÇO</span><span v-else>COMPROVANTE DE RESIDÊNCIA</span>
                  (Modelos: Água, Gás, Energia elétrica, IPTU ou Telefone Fixo)</label></div>
                <div class="m-l" v-if="motivos.cpres">
                  <div><input id="cpresilegivel" type="checkbox" v-model="motivos.cpresIlegivel"> <label
                    for="cpresilegivel" class="control-label">Ilegível - Rasurado, com cortes e/ou incompletos.</label>
                  </div>
                  <div><input id="cpresincorreto" type="checkbox" v-model="motivos.cpresIncorreto"> <label
                    for="cpresincorreto" class="control-label">Incorreto - Divergente do cadastrado no site.</label>
                  </div>
                  <div><input id="cpresemissao" type="checkbox" v-model="motivos.cpresEmissao90dias"> <label
                    for="cpresemissao" class="control-label">Emitido no prazo superior a 90 dias</label></div>
                  <div><input id="cpresconjuge" type="checkbox" v-model="motivos.cpresConjuge"> <label
                    for="cpresconjuge" class="control-label"><span v-if="arrematante.pessoa.tipo === 2">Em nome do(s) Sócio(s)</span><span
                    v-else>Em nome do cônjuge - Enviar Certidão de Casamento e/ou União Estável</span></label></div>
                  <div><input id="cpresterceiros" type="checkbox" v-model="motivos.cpresTerceiros"> <label
                    for="cpresterceiros" class="control-label">Em nome de terceiros - Enviar comprovação de vínculo e
                    Declaração de residência do Detran</label></div>
                </div>
              </div>

            </div>
          </div>

          Tem certeza que deseja alterar o status?<br><br>

          De <span class="label text-sm"
                   :class="'bg-' + getStatus[oldStatus].class">{{getStatus[oldStatus].titulo}}</span>
          para <span class="label text-sm"
                     :class="'bg-' + getStatus[newStatus].class">{{getStatus[newStatus].titulo}}</span>
          <p class="m-t-xl">
            <button ref="btn" tabindex="1" @click="confirm()" class="btn btn-success">Confirmar</button>
            <button tabindex="1" @click="close()" class="btn btn-default">Cancelar</button>
          </p>

        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .u-bg-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.7);
    z-index: 9999996;
  }

  .u-theme-config-container {
    position: fixed;
    z-index: 9999997;
    top: 0;
    bottom: 0;
    margin: auto;
    right: 30px;
    display: flex;
    align-content: center;
    align-items: center;

    &.is-closed {
      animation-name: fecharBonitin;
      animation-duration: .2s;
      -webkit-animation-fill-mode: forwards;
    }
  }

  .u-theme-config i:before {
    font-size: 50px;
  }

  .u-theme-config-panel {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    position: fixed;
    z-index: 9999998;
    right: -300px;
    width: 400px;
    max-height: calc(100vh - 200px);
    background: #fff;
    border-radius: 5px;
    box-shadow: 0 2px 14px 0 rgba(97, 123, 160, 0.4);
    opacity: 0;
    transition: all 0.3s;
    margin: auto;

    &.open {
      right: 25px !important;
      opacity: 1;
      transition: all 0.3s;
    }
  }

  .u-theme-content {
    padding: 22px;
  }

</style>



// WEBPACK FOOTER //
// ConfirmStatusAprovacao.vue?f113d18e